import type {
  CategorySourceDescriptor,
  FeedSourceDescriptor,
  ProductPlatform,
} from '../models/product.types'

export const PRODUCT_FEED_SOURCES: readonly FeedSourceDescriptor[] = [
  {
    platform: 'merchant_center',
    labelKey: 'workspaceDefinitions.platform.merchantCenter',
    channel: 'merchant_center',
    attributeKey: 'merchant_product_id',
    inventoryFeedSource: 'merchantcenter_mainproduct_details',
    rawDataType: 'merchantcenter_mainproduct_details',
  },
  {
    platform: 'meta_catalog',
    labelKey: 'workspaceDefinitions.platform.metaCatalog',
    channel: 'meta_catalog',
    attributeKey: 'metacatalog_product_id',
    inventoryFeedSource: 'metacatalog_products_additional_details',
    rawDataType: 'metacatalog_products',
    mergeWith: 'metacatalog_products_additional_details',
  },
]

export const CATEGORY_SOURCES: readonly CategorySourceDescriptor[] = [
  {
    source: 'ga4',
    labelKey: 'workspaceDefinitions.platform.googleAnalytics',
    channel: 'ga4',
    rawDataType: 'ga4_product',
  },
  ...PRODUCT_FEED_SOURCES.map((source) => ({
    source: source.platform,
    labelKey: source.labelKey,
    channel: source.channel,
    rawDataType: source.rawDataType,
    ...(source.mergeWith ? { mergeWith: source.mergeWith } : {}),
  })),
]

export function productFeedSource(platform: ProductPlatform): FeedSourceDescriptor {
  const descriptor = PRODUCT_FEED_SOURCES.find((item) => item.platform === platform)
  if (!descriptor) throw new Error(`Unknown product feed source: ${platform}`)
  return descriptor
}
